import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertWarningFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,8c-.414,0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75v6c0,.414-.336.75-.75.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "6", cy: "10.5", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAlertWarningFill12.js.map